async function getNewsList(params, navParams) {
    try {

        if (!params || params === 'undefined') {
            id = null;
        }

        if (!navParams || navParams === 'undefined') {
            navParams = null;
        }
        let response = await BX.ajax.runComponentAction(
            componentNewsList.componentName,
            'getNews', {
                mode: 'class',
                signedParameters: componentNewsList.signedParameters,
                data: {
                    templateName: componentNewsList.templateName,
                    params: params,
                    navParams: navParams,
                },
            }).then(function(response) {
            return response;
        });

        return new Promise((resolve, reject) => {
            resolve(response);
        });
    } catch (err) {
        return err.message;
    }
}